

export class AuthModel {
    authorization: string;
}